module.exports = __webpack_public_path__ + "assets/img/shizheng.13f46d79.png";